import { Roles } from 'roles';
import moment from 'moment';

import { DDPRateLimiter } from 'meteor/ddp-rate-limiter';
import { Meteor } from 'meteor/meteor';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { ValidatedMethod } from 'meteor/mdg:validated-method';
import _ from 'lodash';

import { Montgolfieres } from '../montgolfieres/montgolfieres';

export const scheduleAvailability = new ValidatedMethod({
	name: 'availabilities.schedule',
	validate: new SimpleSchema({
		_id: { type: String },
		target: { type: String, allowedValues: ["user", "montgolfiere"] },
		startDate: { type: Date },
		endDate: { type: Date },
		isAvailable: { type: Boolean },
		place: { type: String, allowedValues: ["anjou", "nantes"] },
		period: { type: String, allowedValues: ["morning", "evening"] },
		override: { type: Boolean },
		online: { type: Number },
	}).validator(),
	run({ _id, target, startDate, endDate, isAvailable, place, period, override, online }) {
		let availabilities = [];

		console.log('####################################');

		switch (target) {
			case "user":
				Roles.checkPermission(Meteor.userId(), 'users.update', Meteor.userId(), Meteor.users.findOne(_id));
				const user = Meteor.users.findOne(_id);
				availabilities = user.profile.availabilities || [];
				break;
			case "montgolfiere":
				Roles.checkPermission(Meteor.userId(), 'montgolfieres.update', Meteor.userId(), Meteor.users.findOne(_id));
				const montgolfiere = Montgolfieres.findOne(_id);
				availabilities = montgolfiere.availabilities || [];
				break;
		}

		if (moment(startDate).isAfter(endDate))
			throw new Meteor.Error('invalid_date',
									'La date de début doit être inférieur à la date de fin.');

		let alreadyDefined = false;
		let appended = [];
		startDate = moment(startDate).startOf("day");
		endDate = moment(endDate).endOf("day");

		console.log('startDate', startDate);
		console.log('endDate', endDate);

		/*
		 * Compare each existing availabilities with the new one,
		 * and make required adjustements & erasments
		 */
		availabilities = _.map(availabilities, (availability) => {
			if (availability.period !== period)
				return availability;

			const contains = moment(availability.startDate).isSameOrBefore(startDate)
								&& moment(availability.endDate).isSameOrAfter(endDate);
			const contained =  moment(startDate).isSameOrBefore(availability.startDate)
								&& moment(endDate).isSameOrAfter(availability.endDate);
			const overlapsAtStart = !contained && moment(availability.endDate).isBetween(startDate, endDate, null, '[]');
			const overlapsAtEnd = !contained && moment(availability.startDate).isBetween(startDate, endDate, null, '[]');

			/* In case it's contained or contains */
			if ((contained && availability.isAvailable == isAvailable && availability.place == place)
					|| (contained && override && (availability.isAvailable !== isAvailable || availability.place !== place)))
				return null; // erase existing availability

			if ((contains && availability.isAvailable == isAvailable && availability.place == place)
					|| (contains && !override && (availability.isAvailable !== isAvailable || availability.place !== place)))
				alreadyDefined = true; // erase new availability

			if (contained && !override && (availability.isAvailable !== isAvailable || availability.place !== place)) {
				console.log('preserve existing availability, by splitting the new in 2 sequences MODE NO OVERIDE');
				// preserve existing availability, by splitting the new in 2 sequences
				appended.push({
					startDate: moment(availability.endDate).add(1, 'days').startOf('day').toDate(),
					endDate: endDate.toDate ? endDate.toDate() : endDate,
					place: place,
					period: period,
					isAvailable: isAvailable,
					online: online,
				});
				endDate = moment(availability.startDate).subtract(1, 'days').endOf('day').toDate();

				console.log('availability', availability);
				console.log('appended', appended);
			}

			if (contains && override && (availability.isAvailable !== isAvailable || availability.place !== place)) {
				console.log('preserve new availability, by splitting the current in 2 sequences MODE OVERIDE');
				// preserve new availability, by splitting the current in 2 sequences
				appended.push({
					startDate: moment(endDate).add(1, 'days').startOf('day').toDate(),
					endDate: availability.endDate,
					place: availability.place,
					period: availability.period,
					isAvailable: availability.isAvailable,
					online: availability.online,
				});

				availability.endDate = moment(startDate).subtract(1, 'days').endOf('day').toDate();

				console.log('availability', availability);
				console.log('appended', appended);
			}

			/*
			 *  In case it overlaps,
			 *  we adjust end or start date,
			 *  on current or new availibity,
			 *  according to override setting
			 */
			if ((overlapsAtStart && availability.isAvailable == isAvailable && availability.place == place)
					|| (overlapsAtStart && override && (availability.isAvailable !== isAvailable || availability.place !== place)))
				availability.endDate = moment(startDate).subtract(1, 'days').endOf('day').toDate();

			if (overlapsAtStart && !override && (availability.isAvailable !== isAvailable || availability.place !== place))
				startDate = moment(availability.endDate).add(1, 'days').startOf('day').toDate();

			if ((overlapsAtEnd && availability.isAvailable == isAvailable && availability.place == place)
					|| (overlapsAtEnd && override && (availability.isAvailable !== isAvailable || availability.place !== place)))
				availability.startDate = moment(endDate).add(1, 'days').startOf('day').toDate();

			if (overlapsAtEnd && !override && (availability.isAvailable !== isAvailable || availability.place !== place))
				endDate = moment(availability.startDate).subtract(1, 'days').endOf('day').toDate();

			return availability;
		});


		console.log('Append new availability items if needed');
		/*
		 * Append new availability items if needed
		 */

		startDate = startDate.toDate ? startDate.toDate() : startDate;
		endDate = endDate.toDate ? endDate.toDate() : endDate;
		availabilities = _.compact(availabilities);
		if (!alreadyDefined && moment(startDate).isBefore(endDate))
			availabilities.push({ startDate, endDate, isAvailable, place, period, online });

		console.log('final appended', appended);
		console.log('final availabilities', availabilities);

		availabilities = availabilities.concat(appended);

		switch (target) {
			case "user":
				Meteor.users.update(_id, {
					$set: {
						"profile.availabilities": availabilities
					}
				});
				break;
			case "montgolfiere":
				Montgolfieres.update(_id, {
					$set: {
						availabilities: availabilities
					}
				});
				break;
		}

		return true;
	},
});

export const scheduleManyAvailabilities = new ValidatedMethod({
	name: 'availabilities.scheduleMany',
	validate: new SimpleSchema({
		groups: { type: [Object] },
		"groups.$.place": { type: String },
		"groups.$.period": { type: String },
		"groups.$.items": { type: [Object] },
		"groups.$.items.$.isAvailable": { type: Boolean },
		"groups.$.items.$.target": { type: String },
		"groups.$.items.$._id": { type: String },
		startDate: { type: Date },
		endDate: { type: Date },
		override: { type: Boolean },
		online: { type: Number },
	}).validator(),
	run({ groups, startDate, endDate, override, online }) {
		if (moment(startDate).isAfter(endDate))
			throw new Meteor.Error('invalid_date',
									'La date de début doit être inférieur à la date de fin.');

		_.each(groups, ({ place, period, items }) => {
			_.each(items, ({ _id, target, isAvailable}) => {
				scheduleAvailability.call({
					_id, target, startDate, endDate, isAvailable, place, period, override, online
				});
			});
		});

		return true;
	}
});

// Get list of all method names on Lists
const LISTS_METHODS = _.map([
	scheduleAvailability,
	scheduleManyAvailabilities
], 'name');

if (Meteor.isServer) {
  // Only allow 5 list operations per connection per second
  DDPRateLimiter.addRule({
    name(name) {
      return _.includes(LISTS_METHODS, name);
    },

    // Rate limit per connection ID
    connectionId() { return true; },
  }, 5, 1000);
}



/** WEBPACK FOOTER **
 ** ./src/universal/collections/availabilities/methods.js
 **/